<template>
  <div class="wrapper__content-sale-document col-container">
    <div class="col-header">
      <div class="col-header-left">
        <ButtonCirclePlusComponent
          v-if="$can('payments.manage')"
          @onClick="togglePaymentAdd"
        />
        <span class="col-title">Links cobros</span>
      </div>
      <div class="col-actions">
        <ButtonFilterComponent
          @onChangeFilters="onChangeFilters"
          @onApplyFilters="onApplyFilters"
          :setFilters="searchFilters"
          :loading="loading"
          placeholder="Buscar por número documento"
          isSearch
          isOrderBy
          isDates
          class="mx-2"
        />
      </div>
    </div>
    <template>
      <WrapperScrollbarComponent @scrollingEnd="infiniteHandler">
        <PaymentCardComponent
          v-for="(payment, index) in filterPayments"
          :key="index"
          :payment="payment"
        />
        <infinite-loading
          @distance="90"
          @infinite="infiniteHandler"
          ref="infiniteLoading"
        >
          <div slot="spinner">
            <SkeletonOneCardComponent />
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">
            <PaymentEmptyComponent
              v-if="!payments.length"
              @onPaymentAdd="togglePaymentAdd"
            />
          </div>
        </infinite-loading>
      </WrapperScrollbarComponent>
    </template>
    <PaymentAddComponent
      :visible.sync="isPaymentAdd"
      @onClose="togglePaymentAdd"
    />
  </div>
</template>

<script>
import ButtonCirclePlusComponent from "../../../components/ButtonCirclePlus";
import ButtonFilterComponent from "../../../components/DrawerFilter";
import PaymentCardComponent from "./PaymentCard";
import PaymentEmptyComponent from "./Empty";
import PaymentAddComponent from "./PaymentAdd";
import SkeletonOneCardComponent from "@/components/Animations/Loading/SkeletonOneCard";
import WrapperScrollbarComponent from "../../../../components/WrapperScrollbar";

import paymentService from "../services/paymentService";

export default {
  name: "PaymentColumnsComponent",
  data() {
    return {
      isPaymentAdd: false,
      loading: true,
      searchFilters: {},
      page: 1,
      payments: [],
      breakScroll: false
    };
  },
  computed: {
    filterOrderBy() {
      const { orderBy } = this.searchFilters;
      return orderBy;
    },
    requestFilters() {
      const { search, from, to } = this.searchFilters;
      // Only include defined/non-null values to prevent API confusion
      const filters = {};
      if (search) filters.search = search;
      if (from) filters.from = from;
      if (to) filters.to = to;
      return filters;
    },
    filterPayments() {
      return this.payments.concat().sort((a, b) => {
        if (this.filterOrderBy && this.filterOrderBy === "desc") {
          return a.total > b.total ? -1 : 1;
        } else if (this.filterOrderBy && this.filterOrderBy === "asc") {
          return a.total < b.total ? -1 : 1;
        }
        // Default: sort by date descending (most recent first)
        const dateA = a.created_at ? new Date(a.created_at) : new Date(0);
        const dateB = b.created_at ? new Date(b.created_at) : new Date(0);
        return dateB - dateA;
      });
    },
    getPaymentsFilters() {
      const { documents } = this.$store.getters.getModule("sales");
      return documents.payments.filters.get;
    }
  },
  methods: {
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    togglePaymentAdd() {
      this.goRouter("sales.invoices.add");
      // this.isPaymentAdd = !this.isPaymentAdd;
    },
    updatedSearchFilters(filters) {
      this.searchFilters = {
        ...this.searchFilters,
        ...filters
      };

      this.$store.dispatch("salesDocumentsFiltersGet", {
        documentKey: "payments",
        filters: this.searchFilters
      });
    },
    onChangeFilters(filters) {
      this.updatedSearchFilters(filters);
    },
    onApplyFilters() {
      this.onAsyncDataForDates();
    },
    onAsyncDataForDates() {
      this.payments = [];
      this.page = 1;
      // El aviso de refresco llega con debounce: el componente puede haberse
      // desmontado (navegación) antes de que corra.
      if (!this.$refs.infiniteLoading) return;
      this.$refs.infiniteLoading.stateChanger.reset();
    },
    async getPayments($state) {
      try {
        this.loading = true;
        let response = await paymentService
          .getPayments({
            params: {
              ...{
                page: this.page
              },
              ...this.requestFilters
            }
          })
          .finally(() => {
            this.breakScroll = false;
            this.loading = false;
          });
        const { data } = response.data || {};
        // El interceptor de Api.js "silencia" los GET cancelados por deduplicación
        // devolviendo { data: {} }. Sin este guard, data.length revienta, el catch
        // se lo traga y $state nunca se resuelve: el infinite-loading queda colgado
        // y la columna solo vuelve a cargar recargando la página entera.
        if (!Array.isArray(data)) {
          $state.loaded();
          return;
        }

        if (data.length) {
          if (this.page === 1) {
            this.payments = data;
          } else {
            // Deduplicate: only push items not already in the list
            const existingIds = new Set(this.payments.map(p => p.id));
            const newItems = data.filter(item => !existingIds.has(item.id));
            if (newItems.length === 0) {
              // All returned items are already shown — no more unique data
              $state.complete();
              return;
            }
            newItems.forEach(item => this.payments.push(item));
          }
          this.page = this.page + 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (error) {
        return false;
      }
    },
    infiniteHandler($state) {
      if (!$state || typeof $state.complete !== "function") return;
      if (this.breakScroll) return false;
      this.breakScroll = true;
      this.getPayments($state);
    }
  },
  components: {
    ButtonCirclePlusComponent,
    ButtonFilterComponent,
    PaymentCardComponent,
    PaymentEmptyComponent,
    PaymentAddComponent,
    SkeletonOneCardComponent,
    WrapperScrollbarComponent
  },
  mounted() {
    this.searchFilters = this.getPaymentsFilters;
  }
};
</script>

<style></style>
